import { render, staticRenderFns } from "./MediaClipEditor.vue?vue&type=template&id=748ab63d&scoped=true&"
import script from "./MediaClipEditor.vue?vue&type=script&lang=js&"
export * from "./MediaClipEditor.vue?vue&type=script&lang=js&"
import style0 from "./MediaClipEditor.vue?vue&type=style&index=0&id=748ab63d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748ab63d",
  null
  
)

export default component.exports